import React from "react";
import { ExportButtonContainer, TableHeader } from "./styles";
import { SummaryTableHeaderProps } from "./types";
import { IconDefinition } from "@fortawesome/pro-light-svg-icons";
import Button from "src/components/Button";
import { faPlus } from "@fortawesome/pro-solid-svg-icons";

const SummaryTableHeader = ({ addReportButtonHandler, isLoading }: SummaryTableHeaderProps) => {
  return (
    <TableHeader>
      <ExportButtonContainer>
        <Button
          additionalStyles={{
            float: "unset",
            borderRadius: "10px",
            padding: "9px 20px",
            margin: "0 0 0 auto",
          }}
          loading={isLoading}
          icon={faPlus as IconDefinition}
          text="Create Report"
          onClick={addReportButtonHandler}
        />
      </ExportButtonContainer>
    </TableHeader>
  );
};

export default SummaryTableHeader;
